<script>
  import { CuratedByPageForm } from '@button/ui';
  import Layout from '../components/Layout.svelte';
  import { TOAST_SUCCESS, TOAST_ERROR } from '../constants';
  import { addToast } from '../store';

  const successToast = (message) => {
    addToast({
      message,
      type: TOAST_SUCCESS,
    });
  };

  const errorToast = (message) => {
    addToast({
      message,
      type: TOAST_ERROR,
    });
  };
</script>

<Layout>
  <CuratedByPageForm {successToast} {errorToast} />
</Layout>
